import { render } from "./FooterSettings.vue?vue&type=template&id=43003ed6&scoped=true"
import script from "./FooterSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./FooterSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./FooterSettings.vue?vue&type=style&index=0&id=43003ed6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43003ed6"]])

export default __exports__